import {HttpParameterCodec} from '@angular/common/http';

/**
 * Custom HttpParameterCodec that fully encodes query parameter keys and values
 * using encodeURIComponent / decodeURIComponent.
 *
 * Angular's default HttpUrlEncodingCodec does NOT encode certain characters,
 * most notably '+'. A standard Base64 token (e.g. a page token) can contain '+',
 * which then travels unencoded in the query string and is interpreted by the
 * server as a space — corrupting the token and causing "Invalid page token" (400).
 *
 * Using encodeURIComponent ensures '+' is encoded as '%2B' and survives round-trip.
 */
export class CustomHttpParameterCodec implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
